import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
  AUDIT_COMMENT_GET_REQUEST: "AUDIT_COMMENT_GET_REQUEST",
  AUDIT_COMMENT_GET_SUCCESS: "AUDIT_COMMENT_GET_SUCCESS",
  AUDIT_COMMENT_GET_FAILURE: "AUDIT_COMMENT_GET_FAILURE",

  AUDIT_COMMENT_POST_REQUEST: "AUDIT_COMMENT_POST_REQUEST",
  AUDIT_COMMENT_POST_SUCCESS: "AUDIT_COMMENT_POST_SUCCESS",
  AUDIT_COMMENT_POST_FAILURE: "AUDIT_COMMENT_POST_FAILURE",

  AUDIT_COMMENT_PATCH_REQUEST: "AUDIT_COMMENT_PATCH_REQUEST",
  AUDIT_COMMENT_PATCH_SUCCESS: "AUDIT_COMMENT_PATCH_SUCCESS",
  AUDIT_COMMENT_PATCH_FAILURE: "AUDIT_COMMENT_PATCH_FAILURE",
};

export const actionCreators = {
  getRequest: (auditId) => ({
    type: actionTypes.AUDIT_COMMENT_GET_REQUEST,
    payload: { auditId },
    [WAIT_FOR_ACTION]: actionTypes.AUDIT_COMMENT_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.AUDIT_COMMENT_GET_FAILURE,
  }),

  getSuccess: (auditComments) => ({
    type: actionTypes.AUDIT_COMMENT_GET_SUCCESS,
    payload: auditComments,
  }),

  getFailure: (error) => ({
    type: actionTypes.AUDIT_COMMENT_GET_FAILURE,
    error,
  }),

  postRequest: (auditComment) => ({
    type: actionTypes.AUDIT_COMMENT_POST_REQUEST,
    payload: { auditComment },
    [WAIT_FOR_ACTION]: actionTypes.AUDIT_COMMENT_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.AUDIT_COMMENT_POST_FAILURE,
  }),

  postSuccess: (auditComment) => ({
    type: actionTypes.AUDIT_COMMENT_POST_SUCCESS,
    payload: { auditComment },
  }),

  postFailure: (error) => ({
    type: actionTypes.AUDIT_COMMENT_POST_FAILURE,
    error,
  }),

  patchRequest: (id, data, auditId) => ({
    type: actionTypes.AUDIT_COMMENT_PATCH_REQUEST,
    payload: { id, data, auditId },
    [WAIT_FOR_ACTION]: actionTypes.AUDIT_COMMENT_PATCH_SUCCESS,
    [ERROR_ACTION]: actionTypes.AUDIT_COMMENT_PATCH_FAILURE,
  }),

  patchSuccess: (auditComment) => ({
    type: actionTypes.AUDIT_COMMENT_PATCH_SUCCESS,
    payload: { auditComment },
  }),

  patchFailure: (error) => ({
    type: actionTypes.AUDIT_COMMENT_PATCH_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
